import React from 'react';
import { Grid, Card, CardContent, Typography, Button, Divider,Box } from '@mui/material';
import Slider from 'react-slick';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
const cardData = [
  // {
  //   id: 1,
  //   title: '100YR EDITION',
  //   subtitle: 'ZS ASTOR MT 100 YR EDITION',
  //   price: '₹14,95,800',
  //   image: require('../../images/Astor/astormt.webp'), 
  //   features: [
  //     'Panoramic Sunroof',
  //     'Digital Bluetooth Key Sharing',
  //     'Personal AI Assistant',
  //     'i-Smart with Advanced UI',
  //   ],
  // },
  // {
  //   id: 2,
  //   title: '100YR EDITION',
  //   subtitle: 'ZS ASTOR CVT 100 YR EDITION',
  //   price: '₹16,23,800',
  //   image: require('../../images/Astor/astorcvt.webp'),
  //   features: [
  //     'Panoramic Sunroof',
  //     'Digital Bluetooth Key Sharing',
  //     'Personal AI Assistant',
  //     'i-Smart with Advanced UI',
  //   ],
  // },

  {
    id: 3,
    title: 'SPRINT',
    subtitle: 'ASTOR 5MT(Ivory)',
    price: '₹9,79,100',
    image: 'https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-281.webp?alt=media&token=90de97bc-42a5-4685-9096-b817f1bc336c',
    features: [
      '25.7 cm infotainment',
      '3 steering modes',
      'ABS + EBD + Brake Assist',
      'Hill Hold & Descent Control',
      'ISO FIX Child Anchor',
    ],
  },

  {
    id: 4,
    title: 'SHINE',
    subtitle: 'ASTOR 5MT(Ivory)',
    price: '₹11,34,100',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-0347.webp?alt=media&token=579deab4-41d9-4592-bd13-4149cec10aee",
    features: [
      '25.7 cm infotainment',
      'Push button Engine Start/Stop',
      'Electric Parking Brake with Autohold (CVT)',
      'Silver Finish Roof Rails',
      'R17 Silvery Alloy Wheels',
    ],
  },
  {
    id: 5,
    title: 'SELECT',
    subtitle: 'ASTOR 5MT(Ivory)',
    price: '₹12,40,100',
   image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-281.webp?alt=media&token=90de97bc-42a5-4685-9096-b817f1bc336c",
    features: [
      'Panoramic Skyroof',
      'Wireless Charger (CVT/AT)',
      'Heated ORVM',
      'Wilress Android Auto and Apple Carplay',
      '80+ Connected Car Features with i-Smart 2.0',
      'Digital Bluetooth Key with Key Sharing'
    ],
  },
  // {
  //   id: 6,
  //   title: 'BLACK STORM',
  //   subtitle: 'ASTOR BLACK STORM MT',
  //   price: '₹14,47,800',
  //   image: require('../../images/Astor/blackstorm.webp'),
  //   features: [
  //     'Electronic Stability Program (ESP)',
  //     'ABS + EBD + Brake Assist',
  //     'Traction Control System (TCS)',
  //     'Active cornering brake control (CBC)',
  //     'Hill Hold Control (HHC)',
  //     'Hill Descent Control (HDC) ',
  //   ],
  // },
  {
    id: 7,
    title: 'SHARP PRO',
    subtitle: 'ASTOR 5MT(Ivory)',
    price: '₹13,37,100',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-277.webp?alt=media&token=397ec6c3-4730-4d19-9d15-3ebb2ff7fb85",
    features: [
      'Panoramic Skyroof',
      'Wireless Charger (CVT/AT)',
      'Ventilated Seats',
      'Auto-dimming IRVM​',
      '6 airbags',
      'Dual Tone Sangria Red Interiors ',
      '6-way power adjustable driver seat',
    ],
  },
  {
    id: 8,
    title: 'SELECT',
    subtitle: 'ASTOR 8CVT(Ivory)',
    price: '₹13,56,100',
   image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-279.webp?alt=media&token=ab5a67fd-6afc-46cf-8511-22e6eb414af3",
    features: [
      'Panoramic Skyroof',
      'Wireless Charger (CVT/AT)',
      'Heated ORVM',
      'Wilress Android Auto and Apple Carplay​',
      '80+ Connected Car Features with i-Smart 2.0',
      'Personal AI Assistant',
      'Digital Bluetooth Key with Key Sharing',
    ],
  },
  // {
  //   id: 9,
  //   title: 'BLACK STORM',
  //   subtitle: 'ASTOR BLACK STORM CVT',
  //   price: '₹15,76,800',
  //   image: require('../../images/Astor/blackstorm2.webp'),
  //   features: [
  //     'Electronic Stability Program (ESP)',
  //     'ABS + EBD + Brake Assist',
  //     'Traction Control System (TCS)',
  //     'Active cornering brake control (CBC)',
  //     'Hill Hold Control (HHC)',
  //     'Hill Descent Control (HDC) ',
  //   ],
  // },
  {
    id: 10,
    title: 'SHARP PRO',
    subtitle: 'ASTOR 8CVT(Ivory',
    price: '₹14,52,100',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-278.webp?alt=media&token=e93af8d6-645f-4ec4-b310-b99827156a04",
    features: [
      'Panoramic Skyroof',
      'Wireless Charger (CVT/AT)',
      'Ventilated Seats',
      'Auto-dimming IRVM​',
      '6 airbags',
      'Dual Tone Sangria Red Interiors ',
      '6-way power adjustable driver seat',
    ],
  },
  {
    id: 11,
    title: 'SAVVY PRO',
    subtitle: 'ASTOR 8CVT(Ivory)',
    price: '₹15,30,100',
     image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-280.webp?alt=media&token=49843a90-d02e-47dc-b5d9-938de1b1ae86",
    features: [
      '14 Autonomous Level 2 features',
      '49 Safety Features',
      'Wireless Charger (CVT/AT)',
      'Wilress Android Auto and Apple Carplay',
      'Ventilated Seats',
      'Auto-dimming IRVM',
      'Dual Tone Sangria Red Interiors'
    ],
  },
  {
    id: 12,
    title: 'SAVVY PRO',
    subtitle: 'ASTOR 8CVT(Sangria-red)',
    price: '₹15,30,100',
    image: "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/mg-astor%2Fas-img-dsc-281.webp?alt=media&token=90de97bc-42a5-4685-9096-b817f1bc336c",
    features: [
      '14 Autonomous Level 2 features',
      '49 Safety Features',
      'Wireless Charger (CVT/AT)',
      'Wilress Android Auto and Apple Carplay',
      'Ventilated Seats',
      'Auto-dimming IRVM',
      'Dual Tone Sangria Red Interiors'
    ],
  },
  
  
];



const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowForwardIos
      onClick={onClick}
      style={{ 
        color: 'black', 
        fontSize: '30px', 
        position: 'absolute', 
        top: '50%', 
        right: '10px', 
        cursor: 'pointer', 
        zIndex: 1 
      }}
    />
  );
};

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <ArrowBackIos
      onClick={onClick}
      style={{ 
        color: 'black', 
        fontSize: '30px', 
        position: 'absolute', 
        top: '50%', 
        left: '10px', 
        cursor: 'pointer', 
        zIndex: 1 
      }}
    />
  );
};
// Carousel settings
const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true, // Enable arrows
  nextArrow: <NextArrow />, // Custom next arrow
  prevArrow: <PrevArrow />, // Custom previous arrow
  responsive: [
    {
      breakpoint: 960, // Tablet
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600, // Mobile
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};


const CardGrid = () => {
  // Define card height
  const cardHeight = {md:'780px',xs:'600px',sm:'850px'}; 

  return (
    <Box sx={{
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <Typography variant="h2"
        sx={{
          fontSize: { md: '2.08333vw', xs: '4.2vw' },
          color: '#cf2230',
          fontFamily: 'GillSansSemiBold, Arial, sans-serif',
          paddingBottom: '3.125vw',
          fontWeight: '600',
          marginTop: {md:'80px',xs:'40px',sm:'50px'},
          marginBottom:{xs:'10px'}
        }}>
        MG Astor Model Variants
      </Typography>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <Slider {...settings}>
            {cardData.map((card) => (
              <div key={card.id}>
                <Card
                  sx={{
                    height: cardHeight, 
                    width: {
                      xs: '75%',  // For small screens
                      sm: '87%',  // For medium screens
                      md: '87%',  // For larger screens
                      lg: '75%'  
                    },
                    margin: '5px auto', 
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '16px',
                    boxSizing: 'border-box', 
                    '@media (min-width: 1024px) and (max-width: 1139px)': {
                      width: '300px',
                    },
                  }}
                >
                  <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontFamily: 'GillSansRegular, sans-serif',
                        fontSize: { xs: '4vw', sm: '2.5vw', md: '2vw', lg: '1.27083vw' },
                        color: '#000',
                        marginBottom: '20px',
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { xs: '3vw', sm: '1.6vw', md: '1.5vw', lg: '0.84167vw' },
                        color: '#6e6e6e',
                        marginBottom: { xs: '4vw', sm: '3vw', md: '2vw', lg: '1.0416vw' },
                      }}
                    >
                      {card.subtitle}
                    </Typography>
                    <Button
                      sx={{
                        display: 'inline-block',
                        backgroundColor: '#e1e1e1',
                        borderRadius: '5px',
                        textAlign: 'center',
                        padding: '8px 20px',
                        fontFamily: 'GillSansRegular, sans-serif',
                        fontSize:  { xs: '4vw', sm: '2.1vw', md: '1.5vw', lg: '0.8167vw' },
                        color: '#000',
                        marginBottom: { xs: '2.1vw', sm: '2vw', md: '1vw', lg: '1.04167vw' },
                        '&:hover': { backgroundColor: '#d4d4d4' },
                      }}
                    >
                      Book Now
                    </Button>
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: { xs: '5vw', sm: '2.6vw', md: '2vw', lg: '0.84167vw' },
                        color: '#6e6e6e',
                        marginBottom: { xs: '2vw', sm: '1.5vw', md: '1vw', lg: '.52083vw' },
                      }}
                    >
                      Starts From
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Medium, sans-serif',
                        fontSize:  { xs: '5vw', sm: '4vw', md: '3vw', lg: '1.875vw' },
                        color: '#000',
                        marginBottom: 0,
                      }}
                    >
                      {card.price}
                    </Typography>
                    <img
  src={card.image}
  alt={card.subtitle}
  style={{ width: '100%', objectFit: 'cover' }}
  sx={{
    height: { xs: '100px', md: '200px' }, // Adjust the height for different screen sizes
  }}
/>

                    <ul className="points" style={{ flexGrow: 1 }}>
  {card.features.map((feature, index) => (
    <li
      key={index}
      style={{
        fontFamily: 'Roboto-Regular, sans-serif',
        fontSize: '1.04167vw', // Default for larger screens
        color: '#000',
        marginBottom: '1.04167vw',
      }}
    >
      <Typography
        component="span"
        sx={{
          fontWeight:'600',
          fontSize: { xs: '10px', sm: '12px', md: '1.04167vw' }, // Responsive font sizes
          '@media (max-width: 425px)': {
            fontSize: '12px', 
          },
        }}
      >
        {feature}
      </Typography>
    </li>
  ))}
</ul>


                    <Divider style={{ color: '#D4D4D5' }} />
                    <Typography
                      sx={{
                        fontFamily: 'Roboto-Regular, sans-serif',
                        fontSize: {md:'.9375vw',xs:'10px'},
                        color: '#000',
                        marginTop: '40px',
                        position: 'absolute',
                        bottom: '30px', 
                        width: '100%',
                        textAlign: 'center',
                      }}
                    >
                      Brochure
                    </Typography>
                  </CardContent>
                </Card>
              </div>
            ))}
          </Slider>
        </Grid>
      </Grid>
      {/* <Button
        sx={{
          backgroundColor: '#CF2230',
          color: 'white',
          fontWeight: '700',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontFamily: 'GillSansSemiBold, sans-serif',
          fontSize: { md: '0.95vw', xs: '1.5vw' },
          marginBottom:'40px',
          cursor: 'pointer',
          marginTop: '50px',
          '&:hover': {
            backgroundColor: 'black',
            color: 'white',
          },
        }}
      >
        Compare Variants
      </Button> */}
    </Box>
  );
};

export default CardGrid;